<template>
    <div class="settings-form">

        <!-- Formulário -->
        <div class="form" v-if="!loading">

            <mu-form :model="form">

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="12" lg="8" xl="8">

                        <mu-paper :z-depth="1">

                            <!-- Razão Social / Nome Completo -->
                            <mu-text-field v-model="form.social_name" disabled full-width :label="socialName"></mu-text-field>

                            <mu-row gutter>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Nome Fantasia / Apelido -->
                                    <mu-text-field v-model="form.nick_name" disabled full-width :label="nickName"></mu-text-field>
                                </mu-col>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Documento -->
                                    <mu-text-field v-model="form.document_id" v-mask="maskDocument" disabled full-width :label="document"></mu-text-field>
                                </mu-col>
                            </mu-row>

                            <mu-row gutter v-if="form.typeperson === 'PJ'">
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Inscrição Estadual -->
                                    <mu-text-field v-model="form.reg_state" full-width label="Inscrição Estadual"></mu-text-field>
                                </mu-col>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Inscrição Municipal -->
                                    <mu-text-field v-model="form.reg_town" full-width label="Inscrição Municipal"></mu-text-field>
                                </mu-col>
                            </mu-row>

                            <mu-row gutter>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Telefone Fixo -->
                                    <mu-text-field v-model="form.phone_number" full-width v-mask="['(##) ####-####', '(##) #####-####']" label="Telefone (Fixo)"></mu-text-field>
                                </mu-col>
                                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                    <!-- Telefone Celular -->
                                    <mu-text-field v-model="form.mobile_number" full-width v-mask="['(##) ####-####', '(##) #####-####']" label="Telefone (Celular) *"></mu-text-field>
                                </mu-col>
                            </mu-row>

                            <!-- E-mail -->
                            <mu-text-field v-model="form.email" full-width label="E-mail *"></mu-text-field>

                            <!-- Cada usuário só poderá visualizar suas campanhas. -->
                            <mu-form-item>
                                <mu-checkbox label="Cada usuário só poderá visualizar suas campanhas." v-model="form.showuserreg"></mu-checkbox>
                            </mu-form-item>

                            <!-- Upload de arquivo -->
                            <div class="upload" v-if="!form.logo_url">
                                <input type="file" @change="handleFileUpload">
                                <font-awesome-icon icon="cloud-upload-alt" class="icon-big-extra icon-margin-left"/>
                                <h3 class="title">Selecione o logotipo da empresa</h3>
                                <p>Formatos permitidos: JPG, PNG ou GIF</p>
                            </div>
                            <div class="upload-image" v-else>
                                <mu-row align-items="center">
                                    <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                                        <img :src="getImage()" />
                                    </mu-col>
                                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                                        <div class="button">
                                            <mu-button round @click="removeImage" color="red">
                                                Remover Logotipo
                                            </mu-button>
                                        </div>
                                    </mu-col>
                                </mu-row>
                            </div>

                            <!-- Botão para salvar -->
                            <mu-button round color="primary" @click="saveForm()">
                                <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                                Salvar
                            </mu-button>

                        </mu-paper>

                    </mu-col>
                    <mu-col span="12" sm="12" md="12" lg="4" xl="4">

                        <mu-paper :z-depth="1" class="no-padding">

                            <!-- Chaves -->
                            <div class="channels-list">
                                <mu-data-table :columns="options.keys.columns" :data="options.keys.list" class="mu-table-custom">
                                    <template slot="empty">
                                        <div class="box-table-empty">
                                            Não foi encontrado registros de keys
                                        </div>
                                    </template>
                                    <template slot-scope="scope">
                                        <td>
                                            <strong>{{ scope.row.services.name }}</strong><br>
                                            {{ key_visible ? scope.row.ch1_key : '**********************************' }}
                                        </td>
                                        <td class="is-center">
                                            <a href="javascript:;" @click="key_visible=!key_visible"><font-awesome-icon :icon="key_visible ? 'eye-slash' : 'eye'" /></a>
                                        </td>
                                    </template>
                                </mu-data-table>
                            </div>

                        </mu-paper>

                    </mu-col>
                </mu-row>

            </mu-form>

        </div>

        <!-- Loading -->
        <mu-loading text="Carregando os dados da empresa" v-if="loading"></mu-loading>

    </div>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import { Money, VMoney } from 'v-money'
    import ClientsServices from '@/services/settings/clients'
    import ChannelsServices from '@/services/settings/channels-clients'

    export default {
        name: 'app-settings-form',
        props: ['type'],

        // ╔╦╗╦╦═╗╔═╗╔═╗╔╦╗╦╦  ╦╔═╗╔═╗
        //  ║║║╠╦╝║╣ ║   ║ ║╚╗╔╝║╣ ╚═╗
        // ═╩╝╩╩╚═╚═╝╚═╝ ╩ ╩ ╚╝ ╚═╝╚═╝

        directives: {
            mask,
            money: VMoney
        },

        // ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗
        // ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ╚═╗
        // ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝

        components: {
            'v-money': Money
        },

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                moneyFormat: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2
                },
                options: {
                    keys: {
                        columns: [
                            { title: 'Chaves API', name: 'key' },
                            { title: '', name: 'eye', width: 100, align: 'center' }
                        ],
                        list: []
                    }
                },
                loading: false,
                key_visible: false,
                form: {
                    person_type: 'PJ',
                    social_name: '',
                    nick_name: '',
                    reg_state: '',
                    reg_town: '',
                    document_id: '',
                    phone_number: '',
                    mobile_number: '',
                    email: '',
                    outlay_ceiling_status: false,
                    outlay_ceiling: '',
                    uri_status: '',
                    uri_receive: '',
                    logo_url: '',
                    showuserreg: false
                },
                imageUpload: false
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Carrega os dados para o formulário assim que é construido o componente
         */
        created () {
            this.loadForm()
            this.loadKeys()
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Definindo que tipo de mascara utilizaremos para CNPJ e CPF com base no tipo do cadastro
             */
            maskDocument () {
                return this.form.person_type === 'PJ' ? '##.###.###/####-##' : '###.###.###-##'
            },

            /**
             * Definindo que tipo de label iremos mostrar ao usuário para o campo social name
             */
            socialName () {
                return (this.form.person_type === 'PJ' ? 'Razão Social *' : 'Nome Completo *')
            },

            /**
             * Definindo que tipo de label iremos mostrar ao usuário para o campo nick name
             */
            nickName () {
                return (this.form.person_type === 'PJ' ? 'Nome Fantasia *' : 'Nome *')
            },

            /**
             * Definindo que tipo de label iremos mostrar ao usuário para o campo documento
             */
            document () {
                return (this.form.person_type === 'PJ' ? 'CNPJ *' : 'CPF *')
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            async loadKeys () {
                try {
                    this.loading = true
                    let result = await ChannelsServices.findAll()
                    if (result && result.status) {
                        this.options.keys.list = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.loading = false
                }
            },

            /**
             * Essa função é chamada para carregar os dados da empresa logada
             */
            async loadForm () {
                try {
                    this.loading = true

                    let result = await ClientsServices.profile()

                    if (result && result.status) {
                        this.form = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.loading = false
                }
            },

            /**
             * Função para salvar/atualizar os dados da empresa
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados da empresa.')

                    let result = await ClientsServices.update(this.form)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)

                        let params = {
                            id: this.form.id,
                            name: this.form.nick_name,
                            isProvider: this.form.isprovider,
                            customType: this.form.custom_type,
                            signatureType: this.form.signature_type,
                            logo: this.getImage()
                        }

                        this.$store.dispatch('updateCompany', params)
                        this.$router.push({ name: 'app.settings' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método responsável por montar o caminho da imagem, seja ele absoluto ou em base64
             */
            getImage () {
                if (this.imageUpload) {
                    return this.form.logo_url
                }
                if (this.form.logo_url) {
                    return `${process.env.VUE_APP_STORAGE_LOGOTIPO_PATH}/${this.form.logo_url}?nocache=${Date.now()}`
                }
                return null
            },

            /**
             * Atualiza a imagem quando é alterado o input de imagem
             */
            async handleFileUpload (e) {
                let extensionsPossibles = ['JPG', 'JPEG', 'PNG', 'GIF']
                let files = e.target.files || e.dataTransfer.files
                let extension = files[0].name.split('.').pop()
                if (!extensionsPossibles.includes(extension.toUpperCase())) {
                    this.$eventHub.$emit('snackbar', 'error', `A extensão do arquivo não é permitido (.${extension.toUpperCase()}).`, false)
                    return
                }
                if (!files.length) return
                await this.createImage(files[0])
            },

            /**
             * Responsável por criar a imagem com o base64
             */
            async createImage (file) {
                let reader = new FileReader()
                let vm = this
                reader.onload = async (e) => {
                    vm.form.logo_url = e.target.result
                }
                reader.readAsDataURL(file)
                this.imageUpload = true
            },

            /**
             * Remove o conteúdo da propriedade logo_url para remover a imagem quando
             * os dados forem salvados
             */
            async removeImage (e) {
                this.form.logo_url = ''
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .v-money
        border 1px #ccc solid
        padding 7px 10px
        border-bottom-width 2px
        width 100%

    .no-padding
        padding 0 !important

    .settings-form

        .mu-alert
            text-transform uppercase
            font-size 12px
            strong
                margin-left 10px

        .upload-image
            width 100%
            padding 10px 20px
            border 1px $grey dotted
            margin-bottom 10px

            img
                max-width 120px
                max-height 120px

            .button
                text-align right

        .upload
            width 100%
            padding 20px
            background lighten($grey, 70%)
            border 1px $grey solid
            color darken($grey, 30%)
            text-align center
            position relative
            overflow hidden
            display inline-block
            border-radius 5px
            margin-bottom 20px

            &:hover
                background lighten($grey, 50%)

            img
                max-width 350px
                margin auto

            .title
                margin 0
                color darken($grey, 30%) !important

            p
                margin 0

            .description
                padding-top 20px

                span
                    padding 0 5px

            input[type='file']
                border 0
                width 100%
                z-index 200
                cursor pointer
                position absolute
                left 0
                top 0
                bottom 0
                opacity 0

        .form
            margin 20px 0

            .mu-paper
                padding 20px

                .mu-input
                    margin-bottom 0

            .channels-list
                text-align left
                p
                    background #a7f0f9
                    padding 10px 15px
                    color darken($blue, 30%)
                    margin 0
                    a
                        text-decoration underline
                        color darken($blue, 50%)

            .notifications
                background #eee
                padding 20px;
                border-radius 4px
                border-top 2px $secondary solid
                margin-bottom 20px

                .mu-input-content
                    background #f5f5f5

                .mu-form-item
                    min-height auto !important
                    margin-bottom 0

    .api-title
        margin-top 25px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .form
            .mu-title
                margin-top 0 !important

</style>
